import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  schedule: {
    id: 'dashboard.schedule',
    defaultMessage: 'Schedule',
    description: 'Dashboard schedule',
  },
  noSessionsScheduled: {
    id: 'dashboard.noSessionsScheduled',
    defaultMessage: 'No sessions scheduled',
    description: 'Dashboard no sessions scheduled',
  },
  scheduleLoading: {
    id: 'dashboard.scheduleLoading',
    defaultMessage: 'Loading schedule…',
    description: 'Dashboard schedule card loading state',
  },
  scheduleError: {
    id: 'dashboard.scheduleError',
    defaultMessage: 'Unable to load schedule.',
    description: 'Dashboard schedule card error state',
  },
  scheduleExpandAlt: {
    id: 'dashboard.scheduleExpandAlt',
    defaultMessage: 'Expand schedule',
    description: 'Alt text for the schedule card expand button',
  },
  scheduleModalTitle: {
    id: 'dashboard.scheduleModalTitle',
    defaultMessage: 'Upcoming schedule',
    description: 'Title of the dashboard schedule modal',
  },
  scheduleViewDetails: {
    id: 'dashboard.scheduleViewDetails',
    defaultMessage: 'View details',
    description: 'Link to view event details from the schedule modal',
  },
  scheduleGroupToday: {
    id: 'dashboard.scheduleGroupToday',
    defaultMessage: 'Today',
    description: 'Schedule modal section heading for events happening today',
  },
  scheduleGroupTomorrow: {
    id: 'dashboard.scheduleGroupTomorrow',
    defaultMessage: 'Tomorrow',
    description: 'Schedule modal section heading for events happening tomorrow',
  },
  scheduleGroupThisWeek: {
    id: 'dashboard.scheduleGroupThisWeek',
    defaultMessage: 'This week',
    description: 'Schedule modal section heading for events happening within the next 7 days',
  },
  scheduleGroupLater: {
    id: 'dashboard.scheduleGroupLater',
    defaultMessage: 'Later',
    description: 'Schedule modal section heading for events happening more than a week away',
  },
  assignmentHomework: {
    id: 'dashboard.assignmentType.homework',
    defaultMessage: 'Homework',
    description: 'Schedule event badge for a homework assignment',
  },
  assignmentExam: {
    id: 'dashboard.assignmentType.exam',
    defaultMessage: 'Exam',
    description: 'Schedule event badge for an exam',
  },
  assignmentQuiz: {
    id: 'dashboard.assignmentType.quiz',
    defaultMessage: 'Quiz',
    description: 'Schedule event badge for a quiz',
  },
  assignmentLab: {
    id: 'dashboard.assignmentType.lab',
    defaultMessage: 'Lab',
    description: 'Schedule event badge for a lab assignment',
  },
  assignmentProject: {
    id: 'dashboard.assignmentType.project',
    defaultMessage: 'Project',
    description: 'Schedule event badge for a project assignment',
  },
  assignmentMidterm: {
    id: 'dashboard.assignmentType.midterm',
    defaultMessage: 'Midterm Exam',
    description: 'Schedule event badge for a midterm exam',
  },
  assignmentFinal: {
    id: 'dashboard.assignmentType.final',
    defaultMessage: 'Final Exam',
    description: 'Schedule event badge for a final exam',
  },
  assignmentPractice: {
    id: 'dashboard.assignmentType.practice',
    defaultMessage: 'Practice',
    description: 'Schedule event badge for a practice assignment',
  },
  scheduleStatusLocked: {
    id: 'dashboard.schedule.status.locked',
    defaultMessage: 'Locked',
    description: 'Badge shown when the learner cannot yet access a schedule item',
  },
  scheduleStatusExtended: {
    id: 'dashboard.schedule.status.extended',
    defaultMessage: 'Extended',
    description: 'Badge shown when a due date was extended for this learner',
  },
  scheduleOpens: {
    id: 'dashboard.schedule.opens',
    defaultMessage: 'Opens {date}',
    description: 'Meta label for a future subsection release date',
  },
  scheduleDueInDays: {
    id: 'dashboard.schedule.dueInDays',
    defaultMessage: 'Due in {count, plural, one {# day} other {# days}}',
    description: 'Relative time until an upcoming due date',
  },
  scheduleDueTomorrow: {
    id: 'dashboard.schedule.dueTomorrow',
    defaultMessage: 'Due tomorrow',
    description: 'Relative time when a due date is tomorrow',
  },
  scheduleDueToday: {
    id: 'dashboard.schedule.dueToday',
    defaultMessage: 'Due today',
    description: 'Relative time when a due date is today',
  },
  scheduleOverdue: {
    id: 'dashboard.schedule.overdue',
    defaultMessage: 'Overdue',
    description: 'Relative time when a due date has passed',
  },
  scheduleCourseEndsInDays: {
    id: 'dashboard.schedule.courseEndsInDays',
    defaultMessage: 'Ends {count, plural, =0 {today} one {in # day} other {in # days}}',
    description: 'Relative countdown badge shown on a course end date',
  },
  scheduleExtendedReason: {
    id: 'dashboard.schedule.extendedReason',
    defaultMessage: 'Extended for you: {reason}',
    description: 'Note shown in the modal explaining a granted due-date extension',
  },
  continueLearning: {
    id: 'dashboard.continueLearning',
    defaultMessage: 'Continue Learning',
    description: 'Resume hero CTA shown in the Active Learning state (State C)',
  },
  startLearning: {
    id: 'dashboard.startLearning',
    defaultMessage: 'Start Learning',
    description: 'Start Learning hero CTA shown in the Pre-Engagement state (State B)',
  },
  flashcards: {
    id: 'dashboard.flashcards',
    defaultMessage: 'Flashcards',
    description: 'Dashboard flashcards',
  },
  flashcardsSubtitle: {
    id: 'dashboard.flashcardsSubtitle',
    defaultMessage: 'Personalized recap',
    description: 'Dashboard flashcards subtitle',
  },
  flashcardsLoading: {
    id: 'dashboard.flashcardsLoading',
    defaultMessage: 'Loading flashcards…',
    description: 'Dashboard flashcards loading state',
  },
  flashcardsError: {
    id: 'dashboard.flashcardsError',
    defaultMessage: 'Unable to load flashcards.',
    description: 'Dashboard flashcards error state',
  },
  noFlashcards: {
    id: 'dashboard.noFlashcards',
    defaultMessage: 'No flashcards yet.',
    description: 'Dashboard flashcards empty state',
  },
  ongoingCourses: {
    id: 'dashboard.ongoingCourses',
    defaultMessage: 'On-going Courses',
    description: 'Dashboard ongoing courses',
  },
  ongoingCoursesSubtitle: {
    id: 'dashboard.ongoingCoursesSubtitle',
    defaultMessage: 'Finish the courses you started',
    description: 'Dashboard ongoing courses subtitle',
  },
  noOngoingCourses: {
    id: 'dashboard.noOngoingCourses',
    defaultMessage: 'No on-going courses yet.',
    description: 'Dashboard no ongoing courses empty state',
  },
  flashcardsListLabel: {
    id: 'dashboard.flashcardsListLabel',
    defaultMessage: 'Flashcards list',
    description: 'Accessible label for the flashcards horizontal scroll list',
  },
  ongoingCoursesListLabel: {
    id: 'dashboard.ongoingCoursesListLabel',
    defaultMessage: 'On-going courses list',
    description: 'Accessible label for the ongoing courses horizontal scroll list',
  },
  dismissFlashcard: {
    id: 'dashboard.flashcards.dismiss',
    defaultMessage: 'Dismiss flashcard',
    description: 'Accessible label for the check button that dismisses a flashcard from the dashboard',
  },
  flashcardsScrollPrev: {
    id: 'dashboard.flashcards.scrollPrev',
    defaultMessage: 'Show previous flashcards',
    description: 'Accessible label for the navigation button that scrolls the flashcards row to earlier cards',
  },
  flashcardsScrollNext: {
    id: 'dashboard.flashcards.scrollNext',
    defaultMessage: 'Show next flashcards',
    description: 'Accessible label for the navigation button that scrolls the flashcards row to later cards',
  },
  flashcardTrue: {
    id: 'dashboard.flashcards.true',
    defaultMessage: 'True',
    description: 'Label for the True option on an interactive true/false flashcard',
  },
  flashcardFalse: {
    id: 'dashboard.flashcards.false',
    defaultMessage: 'False',
    description: 'Label for the False option on an interactive true/false flashcard',
  },
  flashcardAnswerCorrect: {
    id: 'dashboard.flashcards.answerCorrect',
    defaultMessage: 'Correct',
    description: 'Feedback shown when the learner picks the right flashcard answer',
  },
  flashcardAnswerIncorrect: {
    id: 'dashboard.flashcards.answerIncorrect',
    defaultMessage: 'Incorrect',
    description: 'Feedback shown when the learner picks the wrong flashcard answer',
  },
  flashcardStartQuiz: {
    id: 'dashboard.flashcards.startQuiz',
    defaultMessage: 'Start Mini Quiz',
    description: 'Fallback CTA label to flip a quiz flashcard when none is provided by the card data',
  },
  flashcardFlip: {
    id: 'dashboard.flashcards.flip',
    defaultMessage: 'Flip flashcard',
    description: 'Accessible label for a text flashcard that can be flipped to reveal the back side',
  },
});

export default messages;
